var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8333 11.5L9.44332 2.16666C9.29703 1.91332 9.08664 1.70294 8.83328 1.55667C8.57992 1.41041 8.29253 1.3334 7.99998 1.3334C7.70744 1.3334 7.42004 1.41041 7.16669 1.55667C6.91333 1.70294 6.70294 1.91332 6.55665 2.16666L1.16665 11.5C1.02032 11.7535 0.943303 12.041 0.943359 12.3337C0.943416 12.6263 1.02054 12.9138 1.16697 13.1672C1.31341 13.4206 1.52399 13.631 1.77753 13.7772C2.03108 13.9234 2.31865 14.0002 2.61132 14H13.3887C13.6812 14 13.9686 13.923 14.222 13.7767C14.4753 13.6304 14.6857 13.42 14.832 13.1666C14.9783 12.9133 15.0553 12.6259 15.0553 12.3333C15.0553 12.0408 14.9783 11.7534 14.832 11.5H14.8333Z",
    fill: "url(#paint0_linear_5608_20316)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00098 10C8.17563 10.0008 8.34428 9.93628 8.4738 9.81909C8.60331 9.70191 8.68434 9.54054 8.70098 9.36668L9.09431 5.43334C9.1083 5.29415 9.09293 5.15357 9.04919 5.02068C9.00545 4.8878 8.93431 4.76557 8.84038 4.6619C8.74645 4.55823 8.63181 4.47542 8.50387 4.41883C8.37593 4.36223 8.23754 4.33311 8.09764 4.33334H7.90431C7.76455 4.33334 7.62635 4.36264 7.49861 4.41933C7.37087 4.47603 7.25643 4.55887 7.16268 4.66252C7.06893 4.76617 6.99794 4.88831 6.9543 5.02108C6.91066 5.15385 6.89533 5.29429 6.90931 5.43334L7.30264 9.36668C7.31925 9.54026 7.40004 9.70139 7.52921 9.81853C7.65837 9.93567 7.8266 10.0004 8.00098 10Z",
    fill: "url(#paint1_linear_5608_20316)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00065 12.6667C8.64498 12.6667 9.16732 12.1443 9.16732 11.5C9.16732 10.8557 8.64498 10.3333 8.00065 10.3333C7.35632 10.3333 6.83398 10.8557 6.83398 11.5C6.83398 12.1443 7.35632 12.6667 8.00065 12.6667Z",
    fill: "url(#paint2_linear_5608_20316)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5608_20316",
    x1: 4.04465,
    y1: 6.77866,
    x2: 14.009,
    y2: 13.7963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F59815"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5608_20316",
    x1: 6.77364,
    y1: 5.19601,
    x2: 9.18431,
    y2: 8.70501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E4154"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B2129"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5608_20316",
    x1: 7.26032,
    y1: 10.7597,
    x2: 8.69265,
    y2: 12.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E4154"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B2129"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.9446216bea3d3d5ccc47d9cf70d623ad.svg";
export { ForwardRef as ReactComponent };